import { useEffect } from 'react';

export const useEmbeddedConfluencePanelCommunication = ({
	closePreviewPanel,
}: {
	closePreviewPanel: () => void;
}): void => {
	// Listen for messages from the legacy embedded Confluence panel to close the active preview panel
	useEffect(() => {
		const handleMessage = (event: MessageEvent) => {
			/*
			 * CLOSE_PREVIEW_PANEL is sent by the legacy embedded Confluence panel when it is opened
			 * to signal that any active preview panel should be closed.
			 * Search for "CLOSE_PREVIEW_PANEL" in to find where message is sent.

			*/
			if (event.data?.type === 'CLOSE_PREVIEW_PANEL') {
				closePreviewPanel();
			}
		};

		globalThis.window.addEventListener('message', handleMessage);

		return () => {
			globalThis.window.removeEventListener('message', handleMessage);
		};
	}, [closePreviewPanel]);
};
